import React from 'react'
import styled from 'styled-components'
import IconArrowDown from '../../../vectors/IconArrowDown'

const SelectFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  & > div {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    width: 100%;
  }

  label {
    line-height: 1;
    font-size: 1rem;
    font-weight: 700;
    color: #1d263a;
  }

  select {
    line-height: 1.2;
    appearance: none;
    border: 0;
    color: #6b6b6b;
    cursor: ${(props) => (props.disabled ? 'cursor' : 'pointer')};
    flex-grow: 1;

    padding-right: 20px;
    padding-bottom: 10px;
    margin-bottom: -10px;

    :focus {
      outline: none;
    }
  }
`

const DropdownIcon = styled(IconArrowDown)`
  position: absolute;
  right: 0;
  top: calc(50% + 2px);
  transform: translateY(-50%);
  margin: auto 0;
  pointer-events: none;
`

export const SelectField = ({
  label,
  value,
  name,
  options,
  onChange,
  disabled
}) => {
  return (
    <SelectFieldWrapper disabled={disabled}>
      <label htmlFor={name}>{label}</label>
      <div>
        <select
          value={value}
          name={name}
          id={name}
          onChange={onChange}
          disabled={disabled}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <DropdownIcon />
      </div>
    </SelectFieldWrapper>
  )
}
